import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col, Container, Table } from "react-bootstrap";
import CustomSwitch from "utils/CustomSwitch";
import { v4 as uuidv4 } from "uuid";
import CustomTooltip from "utils/CustomTooltip";
import CustomFormCheck from "utils/CustomFormCheck";
import PointsofContact from "../PointsOfContact";
import jsDig from "utils/jsDig";

export default function SEO(props) {
  let seoFeeStructure = jsDig(["billing_config", "seo_fee_structure"], props);
  let seoFees = jsDig(["billing_config", "seo_fees"], props);
  const [seoFeesStructure, setSEOFeesStructureDetail] = useState(
    Object.keys(seoFeeStructure).length > 0
      ? seoFeeStructure
      : [{ flat_fee: "0", over_ad_spend: "0", percentage_fee: "0", flat_fee_enabled: "0", percentage_fee_enabled: "0", percentage_fee_total_over: "total" }]
  );
  const [seoFeesDetail, setSEOFeesDetail] = useState(
    seoFees ? seoFees : [{ label: "", amount: "0", status: "0", enabled: "0", status: "Recurring", frequency: "Monthly" }]
  );
  const handleAddSEO = (event) => {
    let newArray = seoFeesStructure;
    newArray.push({
      flat_fee: "0",
      over_ad_spend: "0",
      percentage_fee: "0",
      flat_fee_enabled: "0",
      percentage_fee_enabled: "0",
      percentage_fee_total_over: "total",
    });
    setSEOFeesStructureDetail([...newArray]);
  };
  const handleAddSEOFee = (event) => {
    let newArray = seoFeesDetail;
    newArray.push({ label: "", amount: "0", status: "0", enabled: "0", status: "Recurring", frequency: "Monthly" });
    setSEOFeesDetail([...newArray]);
  };
  const handleChange = (field, index, value) => {
    let newArray = seoFeesDetail;
    newArray[index][field] = value;
    setSEOFeesDetail([...newArray]);
  };
  const handleDeleteStructure = (i) => {
    let remain = seoFeesStructure.filter((web, index) => {
      return i != index;
    });
    setSEOFeesStructureDetail(remain);
  };
  const handleDeleteFee = (i) => {
    let remain = seoFeesDetail.filter((fee, index) => {
      return i != index;
    });
    setSEOFeesDetail(remain);
  };

  return (
    <div className="top-div row mb-5 mr-0 ml-0">
      <div className="col agreement-col" style={{ backgroundColor: "#EEEEEE" }}>
        <CustomSwitch
          isEnabled={props.isEnabled}
          setIsEnabled={props.setIsEnabled}
          text="SEO"
          variant="seo"
          customClass="d-inline-block"
          id="seo-enable"
          name={`seo_enabled`}
          label={
            <p className="seo-color pb-0 f28 visby-bold pl-3 mb-0" style={{ marginTop: "-5px" }}>
              SEO
            </p>
          }
          checked={props.isEnabled}
        />
        <div style={{ display: props.isEnabled ? undefined : "none" }}>
          <p className="f22 light-primary visby-bold agreement mb-2">Agreement</p>
          <div className="shared-fee-structure mb-5">
            <div className="table-responsive">
              <Table className="pb-3">
                <thead>
                  <tr>
                    <th>
                      <h4 className="d-inline-block light-primary ml-2 mr-2 visby-bold">Select and set shared fee structure</h4>
                      <CustomTooltip
                        faClass="far fa-question-circle"
                        message="This is where you can dictate how a client will be charged based on their revenue. You can set multiple thresholds for ad spend on the left, and then tell DataPulse whether you would like to charge a fixed dollar amount, or a percentage of that revenue for each threshold with the boxes on the right. In the case of charging a percentage, you can also specify whether you would like to charge a percentage of the total revenue, or only the percentage of the amount that is over the specified threshold."
                        inline={true}
                      />
                    </th>
                    <th className="f12 pl-4 nunito-regular  light-primary" style={{ paddingLeft: "35px" }}>
                      Fixed amount
                    </th>
                    <th className="f12 pl-2 nunito-regular  light-primary" style={{ paddingLeft: "35px" }}>
                      Revenue (total or above)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {seoFeesStructure.map((detail, index) => {
                    const flatFeeEnabled = detail["flat_fee_enabled"] == "1";
                    const percentageEnabled = detail["percentage_fee_enabled"] == "1";
                    return (
                      <tr key={index}>
                        <td className="pr-0">
                          <div className="mr-3 input-box1">
                            Over revenue
                            <Form.Control
                              size="sm"
                              className="cw1 mr-2"
                              placeholder="0"
                              name={`seo_fee_structure[][over_ad_spend]`}
                              value={detail ? detail.over_ad_spend : 0}
                              onChange={(e) => {
                                let newArray = seoFeesStructure;
                                newArray[index]["over_ad_spend"] = e.target.value;
                                setSEOFeesStructureDetail([...newArray]);
                              }}
                            />
                            <span className="unit">$</span>
                            charge
                          </div>
                        </td>
                        <td className="pr-0">
                          <div className="d-flex align-items-center">
                            <div style={{ width: "16px" }} className="pr-2">
                              <CustomFormCheck
                                id={`seocharge ` + `${index}`}
                                name={`seo_fee_structure[][flat_fee_enabled]`}
                                checked={flatFeeEnabled}
                                sendUncheckedValue={!flatFeeEnabled}
                                onChange={() => {
                                  let newArray = seoFeesStructure;
                                  newArray[index]["flat_fee_enabled"] = !flatFeeEnabled;
                                  setSEOFeesStructureDetail([...newArray]);
                                }}
                              />
                            </div>
                            <div className="input-box2 mr-3">
                              <Form.Control
                                size="sm"
                                disabled={!flatFeeEnabled}
                                style={{ opacity: flatFeeEnabled ? true : "0.6" }}
                                className="cw2"
                                placeholder="0"
                                name={`seo_fee_structure[][flat_fee]`}
                                value={detail ? detail.flat_fee : 0}
                                onChange={(e) => {
                                  let newArray = seoFeesStructure;
                                  newArray[index]["flat_fee"] = e.target.value;
                                  setSEOFeesStructureDetail([...newArray]);
                                }}
                              />
                              <span style={{ opacity: flatFeeEnabled ? null : "0.6" }} className="unit">
                                $
                              </span>
                            </div>
                          </div>
                        </td>
                        <td className="p-0">
                          <div className="d-flex pl-0  align-items-center">
                            <div style={{ width: "16px" }}>
                              <CustomFormCheck
                                name={`seo_fee_structure[][percentage_fee_enabled]`}
                                checked={percentageEnabled}
                                sendUncheckedValue={!percentageEnabled}
                                id={`seorev ` + `${index}`}
                                onChange={() => {
                                  let newArray = seoFeesStructure;
                                  newArray[index]["percentage_fee_enabled"] = !percentageEnabled;
                                  setSEOFeesStructureDetail([...newArray]);
                                }}
                              />
                            </div>
                            <Form.Control
                              className="mr-0"
                              as="select"
                              size="sm"
                              disabled={!percentageEnabled}
                              style={{ opacity: percentageEnabled ? true : "0.6" }}
                              name={`seo_fee_structure[][percentage_fee_total_over]`}
                              placeholder="0"
                              defaultValue={detail ? detail.percentage_fee_total_over : 0}>
                              <option value="total">total</option>
                              <option value="over">partial</option>
                            </Form.Control>
                            <div className="input-box3">
                              <Form.Control
                                className="ml-2 mr-3"
                                disabled={!percentageEnabled}
                                size="sm"
                                style={{ width: "100px", color: "#30336a", opacity: percentageEnabled ? true : "0.6" }}
                                placeholder="0"
                                name={`seo_fee_structure[][percentage_fee]`}
                                value={detail ? detail.percentage_fee : 0}
                                onChange={(e) => {
                                  let newArray = seoFeesStructure;
                                  newArray[index]["percentage_fee"] = e.target.value;
                                  setSEOFeesStructureDetail([...newArray]);
                                }}
                              />
                              <span style={{ opacity: percentageEnabled ? null : "0.6" }} className="unit">
                                %
                              </span>
                            </div>
                            {(index >=  0 && seoFeesStructure.length > 1) && <i className="fas fa-minus-circle" onClick={(e) => handleDeleteStructure(index)}></i>}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <Button style={{ marginLeft: "12px" }} className="mt-3 btn-sm center-mobile-button" variant="success" onClick={handleAddSEO}>
              + Add Condition
            </Button>
          </div>
          <div className="active-seo-fees">
            <h4 className="d-inline-block pr-2 light-primary visby-bold">Active SEO Fees</h4>
            <h5 style={{ visibility: "hidden" }} className="d-inline-block ppc-color">
              View full history
            </h5>
            <div className="mb-5">
              <div className="table-responsive">
                <Table className="pb-3">
                  <thead>
                    <tr>
                      <th></th>
                      <th className="pl-3 light-primary">Frequency</th>
                      <th className="pl-3 light-primary">Label</th>
                      <th className="pl-3 light-primary">Amount</th>
                      <th style={{ visibility: "hidden" }} className="light-primary">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {seoFeesDetail.map((detail, index) => {
                      const seoFeeEnabled = detail["enabled"] == "1";
                      const greyout = seoFeeEnabled ? null : { opacity: "0.6" };
                      return (
                        <tr key={index}>
                          <td>
                            <div style={{ width: "16px" }}>
                              <CustomFormCheck
                                name={`seo_fees[][enabled]`}
                                id={`seo-fee ` + `${index}`}
                                checked={seoFeeEnabled}
                                sendUncheckedValue={!seoFeeEnabled}
                                onChange={() => {
                                  let newSEOFeeEnabled = seoFeesDetail;
                                  newSEOFeeEnabled[index]["enabled"] = !seoFeeEnabled;
                                  setSEOFeesDetail([...newSEOFeeEnabled]);
                                }}
                              />
                            </div>
                          </td>
                          <td style={greyout}>
                            <Form.Control
                              as="select"
                              size="sm"
                              name={`seo_fees[][frequency]`}
                              defaultValue={detail ? detail.frequency : 0}
                              disabled={!seoFeeEnabled}>
                              <option value="Monthly">Monthly</option>
                              <option value="One-time">One-time</option>
                            </Form.Control>
                          </td>
                          <td style={greyout}>
                            <Form.Control
                              size="sm"
                              className="ml-0 cw1"
                              name={"seo_fees[][label]"}
                              value={detail.label}
                              onChange={(e) => handleChange("label", index, e.target.value)}
                              disabled={!seoFeeEnabled}
                            />
                          </td>
                          <td style={greyout}>
                            <div className="row d-flex align-items-center">
                              <div className="input-box2">
                                <Form.Control
                                  size="sm"
                                  placeholder="0"
                                  style={{ width: "100px", backgroundColor: seoFeeEnabled ? "white" : "#F8F8F8" }}
                                  name="seo_fees[][amount]"
                                  value={detail.amount}
                                  onChange={(e) => handleChange("amount", index, e.target.value)}
                                  disabled={!seoFeeEnabled}
                                />
                                <span className="unit">$</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              <i className="fas fa-minus-circle" onClick={(e) => handleDeleteFee(index)}></i>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <Button className="mt-3 btn-sm center-mobile-button" variant="success" onClick={handleAddSEOFee}>
                + Add fee
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col" style={{ backgroundColor: "#EEEEEE", display: props.isEnabled ? undefined : "none" }}>
        <PointsofContact {...props} group="seo" />
      </div>
    </div>
  );
}
